export class ApplicationNote {
    status: string = '';
    note: string = '';
    signature: string = '';
    timestamp: string = '';

    public constructor(init?: Partial<ApplicationNote>) {
        Object.assign(this, init);
    }
}